import { render } from "./OrderBookingDetail.vue?vue&type=template&id=977cd4d6&scoped=true&ts=true"
import script from "./OrderBookingDetail.vue?vue&type=script&lang=ts"
export * from "./OrderBookingDetail.vue?vue&type=script&lang=ts"

import "./OrderBookingDetail.vue?vue&type=style&index=0&id=977cd4d6&lang=sass&scoped=true"
import "./OrderBookingDetail.vue?vue&type=style&index=1&id=977cd4d6&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977cd4d6"]])

export default __exports__